module.exports = __webpack_public_path__ + "static/media/Burger.8787a7ae.svg";